import React, { useContext, useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { List, Pagination, Space, Spin, message } from 'antd';

import Configurazione from '../../Configurazione';
import sessionManager, { eVariableType } from '../../SessionManager';
import { GetErrorMessage } from '../../Utility';
import api, { apiClienti } from '../../api';
import FiltriMagazzino, { filtriFields } from '../FiltriMagazzino';
import HeaderBar from '../HeaderBar';
import BloccoCardMagCli from './BloccoCardMagCli';
import './Main.css';

export default function MagazzinoClienti() {
    const [isRunning, setIsunning] = useState(false);
    const [totalRighe, setTotalRighe] = useState(1);
    const [data, setData] = useState<any>([]);

    const tpdiv = useRef<HTMLDivElement | null>(null);

    const [querystring, setQuerystring] = useSearchParams();

    useEffect(() => {
        fetchData(querystring, 1);
    }, [querystring]);

    async function fetchData(e: URLSearchParams, cpage: number) {
        setIsunning(true);

        try {
            const dt = {
                idSocieta: Configurazione().idsocieta,
                idQualita: e.getAll('iq'),
                codFinitura: e.getAll('cf'),
                numeroBlocco: e.get('nb'),
                numeroBloccoFornitore: e.get('nbf'),
                indice: (cpage - 1) * Configurazione().maxResultsPerPage,
                numeroRighe: Configurazione().maxResultsPerPage,
            };

            const result = await apiClienti().post('Magazzino/StockClienteGroupByBlocco', dt);

            if (result != null) {
                if (
                    Array.isArray(result.data) &&
                    result.data.length > 0 &&
                    result.data[0] !== null &&
                    result.data[0] !== undefined
                ) {
                    setData(result.data);
                    setTotalRighe(result.data[0].totaleRighe);
                } else {
                    setData(null);
                }
            } else {
                setData(null);
            }
        } catch (error) {
            message.error(GetErrorMessage(error));
        } finally {
            setIsunning(false);
        }
    }

    function onConfirmFiltri(e: filtriFields) {
        const pr = new URLSearchParams();

        e.codFinitura ? e.codFinitura.forEach((value) => pr.append('cf', value)) : null;
        e.idQualita ? e.idQualita.forEach((value) => pr.append('iq', value.toString())) : null;
        e.numeroBlocco ? pr.append('nb', e.numeroBlocco) : null;
        e.numeroBloccoFornitore ? pr.append('nbf', e.numeroBloccoFornitore) : null;
        e.numFattura ? pr.append('nf', e.numFattura) : null;
        e.fatturate ? pr.append('f', e.fatturate) : null;
        setQuerystring(pr);

        fetchData(pr, 1);
    }

    function onChangePage(page: any) {
        scroll2top();
        fetchData(querystring, page);
    }

    function scroll2top() {
        if (tpdiv.current) {
            tpdiv.current.scrollIntoView({ behavior: 'smooth' });
        }
    }

    return (
        <div style={{ margin: '0px' }}>
            <div ref={tpdiv}></div>
            <HeaderBar descrizione="Magazzino" menuSelezionato="MagazzinoClienti"></HeaderBar>
            <Space className="App-body" direction="vertical">
                <FiltriMagazzino
                    numeroBloccoVisible={true}
                    numeroBloccoFornitoreVisible={true}
                    fatturazioneVisible={false}
                    finituraVisible={true}
                    periodoVisible={false}
                    qualitaVisible={true}
                    dataIni={null}
                    params={querystring}
                    contoTerzi={true}
                    onconfirm={(e: filtriFields) => onConfirmFiltri(e)}
                ></FiltriMagazzino>
                <hr></hr>
                <Spin spinning={isRunning} size="large">
                    <List
                        style={{ alignSelf: 'center', textAlign: 'center' }}
                        dataSource={data || []}
                        grid={{ xs: 1, sm: 2, md: 3, lg: 3, xl: 3, xxl: 3 }}
                        renderItem={(item: any) => {
                            return (
                                <BloccoCardMagCli
                                    key={item?.numeroBloccoFornitore}
                                    nomefile={item?.nomeFile}
                                    qualita={item?.qualita}
                                    numeroBloccoFornitore={item?.numeroBloccoFornitore}
                                    numeroBlocco={item?.numeroBlocco}
                                    monolama={item?.monolama}
                                    idQualita={item.idQualita}
                                    codFinitura={item.codFinitura}
                                    spessore={item.spessore}
                                    pezzi={item?.pezzi}
                                    isCliente={true}
                                    um={item?.um}
                                    params={querystring}
                                ></BloccoCardMagCli>
                            );
                        }}
                    ></List>
                    <div style={{ marginBottom: '50px', textAlign: 'center' }}>
                        <Pagination
                            total={totalRighe}
                            defaultPageSize={Configurazione().maxResultsPerPage}
                            onChange={onChangePage}
                        />
                    </div>
                </Spin>
            </Space>
        </div>
    );
}
